import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Form, FormGroup } from "reactstrap";
import { Prompt } from "react-router";
import PropTypes from "prop-types";
import _, { cloneWith, startsWith } from "lodash";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";

import {
  InputText,
  Dropdown,
  Loading,
  RecipePageRecipeFormDropdown,
  InputAmount,
  Valert,
  VautoComplete,
  ListingText,
  Vmodal,
  InputHHMM,
} from "../components";
import recipeActions from "../actions/recipeActions";
import "./styles/recipe.css";
import "./styles/recipeModern.css";
import {
  ACTIVITY_UNITS,
  SYMPTOM_UNITS_NEW,
  FOOD_UNITS,
  DRUG_UNITS,
  PCP_UNITS,
  SUP_UNITS,
  LOC_UNITS,
} from "../actions/constant";
import i18n from "../i18n";
import { checkInput, SetupPageWithBFCacheAndPrompt, compressImageSmart, sanitizeEncodeImage } from "../lib/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

const CUISINE_CLICK_COUNT_KEY = "CUISINE_CLICK_COUNT_KEY";
const CUISINE_CURRENT_VALUE = "CUISINE_CURRENT_VALUE";
const SIZE_KEY = "SIZE_KEY";

class IngredientForm extends Component {
  constructor(props) {
    super(props);
    this.amountRef = React.createRef();
    this.state = {
      value: "",
      autoIngredientValidator: "",
      symbolValue: "",
      symbolValidator: "",
      sizeValue: "",
      sizeValidator: "",
    };
    this.selectIngredientOptions = this.selectIngredientOptions.bind(this);
    this.symbolOnChange = this.symbolOnChange.bind(this);
    this.sizeOnChange = this.sizeOnChange.bind(this);
    this.stateChanger = this.stateChanger.bind(this);
    this.onChangeIngredientForm = this.onChangeIngredientForm.bind(this);
    this.handleSemiColonInAmount = this.handleSemiColonInAmount.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  stateChanger(key, value) {
    var data = {};
    data[key] = value;
    this.setState(data, function () { });
  }
  //functions
  symbolOnChange(e) {
    var val = e.target.value == "null" ? "" : e.target.value;
    this.setState({ symbolValue: val });
    if (val) {
      this.setState({ symbolValidator: "" });
    }
    e.target.val = val;
    this.props.onChangeIngredientForm(e);
    return true;
  }
  sizeOnChange(event) {
    var word = event.target.value;
    if (word || word != "null") {
      this.setState({ sizeValidator: "" });
    }
    return true;
  }
  selectIngredientOptions(e) {
    var resultVal = e.recipe;
    var flagVal = false;
    if (e) flagVal = true;
    if (flagVal) {
      this.props.change("_id", e._id);
      this.props.change("ingredientFlag", true);
    } else {
      this.props.change("_id", undefined);
      this.props.change("ingredientFlag", false);
    }
    this.props.change("recipes", resultVal);
    this.props.change("recipe", e.recipe_full);
    this.props.IngredientOptionSelected(e);
  }
  amountReset() {
    this.amountRef.valueChenger("");
  }
  amountChanger(val) {
    this.amountRef.valueChenger(val);
  }
  onChangeIngredientForm(e) {
    this.props.onChangeIngredientForm(e);
  }

  handleSemiColonInAmount = () => {
    const { measurementOptions } = this.props;
    const supportsHHMM =
      Array.isArray(measurementOptions) &&
      measurementOptions.some(opt => String(opt.value) === "445");

    // If no HHMM unit, stop execution
    if (!supportsHHMM) return;

    // ✅ If HHMM unit, switch to HHMM mode
    this.props.setHHMMMode(true);

    // ✅ Auto-select HHMM unit if not already selected
    this.onChangeIngredientForm({ target: { name: "unitid", value: "445" } });
  };

  render() {
    let props = this.props;
    const { t, ingredientForm, recipeForm, barcode } = this.props;
    const positive = (value) => {
      if (value < 0) {
        return 0;
      } else {
        return value;
      }
    };
    return (
      <Form>
        <FormGroup row>
          <Col>
            <Field
              name="recipe"
              component={VautoComplete}
              disabled={this.props.disabled.ingredientName}
              placeholder={
                recipeForm.category == "01"
                  ? this.props.t("symptoms.ITEM_INPUT_TEXT_SYMPTOM")
                  : recipeForm.category == "02"
                    ? this.props.t("general.FOOD_PLACEHOLDER")
                    : recipeForm.category == "03"
                      ? this.props.t("general.ACTIVITY_PLACEHOLDER")
                      : recipeForm.category == "04"
                        ? this.props.t("general.PCP_PLACEHOLDER")
                        : recipeForm.category == "05"
                          ? this.props.t("general.MEDICINE_PLACEHOLDER")
                          : recipeForm.category == "06"
                            ? this.props.t("general.SUPPLEMENT_PLACEHOLDER")
                            : recipeForm.category == "07"
                              ? this.props.t("general.LOCATION_PLACEHOLDER")
                              : recipeForm.category == "999"
                                ? this.props.t("general.FOOD_PLACEHOLDER")
                                : this.props.t("recipe.INGREDIENT_FIELD_DEFAULT_TEXT")
              }
              ref={this.inputFileRef}
              show={this.state.show}
              onChangeText={this.props.searchIngredientOptions}
              onSelect={this.selectIngredientOptions}
              val={ingredientForm.recipe_full || ""}
              category={
                this.props.recipeForm.category == "999"
                  ? "02"
                  : this.props.recipeForm.category
              }
              level="111111001"
              append={ingredientForm && ingredientForm.upc}
              position="top"
              sType={"4"}
              onClear={() => this.props.searchIngredientOptions("", true)}
              showCross={true}
              bodyMapClicked={
                this.props.recipeForm.category === "01" &&
                !ingredientForm.vId &&
                this.props.bodyMapClicked
              }
              barcodeClicked={
                this.props.recipeForm.category &&
                  (this.props.recipeForm.category == "999" ||
                    this.props.recipeForm.category == "02" ||
                    this.props.recipeForm.category == "04" ||
                    this.props.recipeForm.category == "05" ||
                    this.props.recipeForm.category == "06")
                  ? this.props.barcodeClicked
                  : false
              }
              barcodeImageClicked={this.props.barcodeImageClicked}
              barcode={barcode}
              partialResult={this.props.partialResult}
              showPartial={
                this.props.partialResult && this.props.partialResult.length > 0
                  ? true
                  : false
              }
              barcodeSearch={this.props.barcodeSearch}
              showNoneOfAbove={true}
              showNoneOfAboveText={this.props.t("BARCODE.NONE_OF_ABOVE")}
              addCustomAlert={this.props.addCustomAlert}
              showHistory={false}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              name="unitid"
              component={Dropdown}
              options={props.measurementOptions}
              val={
                this.props.ingredientForm && this.props.ingredientForm.unitid
              }
              placeholder={
                props.measurementOptions.length === 1
                  ? ""
                  : t("symptoms.ITEM_UNIT_TEXT")
              }
              className={`${this.state.symbolValidator && "is-invalid"}`}
              onChange={this.symbolOnChange}
              disabled={
                props.measurementOptions.length === 1
                  ? true
                  : this.props.disabled.ingredientunit
              }
            />
            {this.state.symbolValidator && (
              <div className="invalid-feedback">
                {this.state.symbolValidator}
              </div>
            )}
          </Col>
          <Col>
            {props.scaleOptions.length !== 0 ? (
              <Field
                key={`scale-dropdown-${this.props.amountReseter}`}
                name="size"
                component={Dropdown}
                options={props.scaleOptions}
                val={
                  this.props.ingredientForm.size
                    ? this.props.ingredientForm.size
                    : ""
                }
                placeholder={
                  this.props.recipeForm.category == "01"
                    ? t("general.ITEM_VALUE_TEXT_SYMPTOM")
                    : t("general.ITEM_VALUE_TEXT")
                }
                readOnly={this.props.disabled.ingredientsize}
                disabled={this.props.disabled.ingredientsize}
                onChange={(e) => this.onChangeIngredientForm(e)}
                amounNewValue={this.props.amounNewValue}
                reseter={this.props.amountReseter}
              />
            ) : this.props.hhmmMode ? (
              // 🕒 HH:MM entry when semicolon mode is active
              <Field
                key={`scale-hhmm-${this.props.amountReseter}`}
                component={InputHHMM}
                name="size"
                placeholder_HH={t("general.ITEM_VALUE_TEXT_HH")}
                placeholder_MM={t("general.ITEM_VALUE_TEXT_MM")}
                className="hhmm-styled"
                disabled={this.props.disabled.ingredientsize}
                onChangeSymptomForm={(e) =>
                  this.onChangeIngredientForm({
                    target: { name: "size", value: (e && e.target && e.target.value) || "" },
                  })
                }
                semicolonTriggered={this.props.hhmmMode}
              />
            ) : (
              // 🔢 Default type-in input (fraction or decimal)
              <Field
                key={`scale-text-${this.props.amountReseter}`}
                component={InputAmount}
                normalize={positive}
                name="size"
                placeholder={
                  this.props.recipeForm.category &&
                    this.props.recipeForm.category == "01"
                    ? t("general.ITEM_VALUE_TEXT_SYMPTOM")
                    : t("general.ITEM_VALUE_TEXT")
                }
                onKeyUp={(e) => this.onChangeIngredientForm(e)}
                onSemiColonTyped={(val) => this.handleSemiColonInAmount(val)}  // Handles "HH:MM"
                amounNewValue={this.props.amounNewValue}
                reseter={this.props.amountReseter}
                mode="allowfraction"
                className={`${this.state.sizeValidator && "is-invalid"}`}
                disabled={this.props.disabled.ingredientsize}
                HHMM_Allowed={
                  Array.isArray(this.props.measurementOptions) &&
                  this.props.measurementOptions.some(opt => String(opt.value) === "445")
                }
              />
            )}
          </Col>
        </FormGroup>
        <Field
          component={InputText}
          type="hidden"
          name="index"
          placeholder="Index"
        />
        <Field
          component={InputText}
          type="hidden"
          name="_id"
          placeholder="Id"
        />
      </Form>
    );
  }
}

IngredientForm = reduxForm({
  form: "formRecipeIngredient",
  enableReinitialize: true,
})(IngredientForm);

IngredientForm = connect((state) => ({
  initialValues: state.recipe.ingredientForm,
}))(IngredientForm);

class RecipeForm extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      autoRecipeValidator: "",
      cuisineValidator: "",
    };

    this.stateChanger = this.stateChanger.bind(this);
    this.recipeOnChange = this.recipeOnChange.bind(this);
    this.recipeFocus = this.recipeFocus.bind(this);
    // Cuisine Dropdown methods
    this.cuisineOnChange = this.cuisineOnChange.bind(this);
    this.getCurrentSelectedCuisine = this.getCurrentSelectedCuisine.bind(this);
    this.setCurrentSelectedCuisine = this.setCurrentSelectedCuisine.bind(this);
    this.getCurrentCuisineClickCount =
      this.getCurrentCuisineClickCount.bind(this);
    this.setCurrentCuisineClickCount =
      this.setCurrentCuisineClickCount.bind(this);
    // Size Dropdown
    this.onSizeChanged = this.onSizeChanged.bind(this);
    this.getCurrentSelectedSize = this.getCurrentSelectedSize.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    this.setCurrentCuisineClickCount(0);
    this.setCurrentSelectedCuisine("");
  }
  stateChanger(key, value) {
    var data = {};
    data[key] = value;
    this.setState(data, function () { });
  }
  onSizeChanged(event) {
    this.props.onChangeRecipeForm(event);
  }
  getCurrentSelectedSize() {
    var size = localStorage.getItem(SIZE_KEY);
    return size;
  }
  getCurrentSelectedCuisine() {
    return localStorage.getItem(CUISINE_CURRENT_VALUE);
  }
  setCurrentSelectedCuisine(p_cuisineName) {
    localStorage.setItem(CUISINE_CURRENT_VALUE, p_cuisineName);
  }
  getCurrentCuisineClickCount() {
    return localStorage.getItem(CUISINE_CLICK_COUNT_KEY);
  }
  setCurrentCuisineClickCount(p_clickCount) {
    localStorage.setItem(CUISINE_CLICK_COUNT_KEY, p_clickCount);
  }
  cuisineOnChange(event) {
    this.props.onChangeRecipeForm(event);
    if (event.target.value || event.target.value != "null") {
      this.setState({ cuisineValidator: "" });
    }
    if (event.target.value === "20002001001") {
      this.props.otherCuisineModal(event);
      this.setCurrentCuisineClickCount(0);
      this.setCurrentSelectedCuisine(
        this.props.t("recipe.CUISINE_DROPDOWN_VALUE_OTHER")
      );
    } else {
      this.setCurrentSelectedCuisine(event.target.value);
    }

    return true;
  }
  recipeOnChange = (val) => {
    if (window.id == "") {
      this.props.change("_id", "");
      this.props.change("user", "");
    }
    this.props.searchRecipeOptions(val, { replaceAlert: this.props.replaceAlert });
    return true;
  };
  recipeFocus = (e) => { };
  replaceOrAddRecipe(e) {
    let ingredientsLength = this.props.recipeForm.category === "999"
      ? e.ingredients.length
      : e.items.length;

    const recipeName = e.recipe_full || e.recipe || e.fullname || e.name;

    // Case 1: Has ingredient/content AND display area not empty => prompt
    if (
      ingredientsLength > 0 &&
      this.props.ingredientList &&
      this.props.ingredientList.length > 0
    ) {
      this.pendingSelection = e; // cache the selection synchronously (no setState race)
      this.props.replaceAlert.changeStatus();
      // ❌ don't call updateRecipeName/getRecipe here
      return;
    }

    // Case 2: Has ingredient/content AND display area empty => heavy acceptor
    if (ingredientsLength) {
      this.props.getIngredients(e);
      return;
    }

    // Case 3: Custom Item selection => light acceptor
    this.props.updateRecipeName(recipeName, true, "", e._id);
  }
  render() {
    let props = this.props;
    const { t, recipeForm } = this.props;
    let servingOptions = [];

    _.times(50, (i) => {
      const serving = i + 1;
      servingOptions.push({ value: serving, label: serving });
    });
    return (
      <Form onSubmit={props.handleSubmit}>
        <FormGroup row>
          <Col sm={{ size: 9 }}>
            <Field
              name="category"
              component={Dropdown}
              options={i18n.t("KIT_CAT", { returnObjects: true })}
              placeholder={this.props.t("symptoms.CATEGORY_TEXT")}
              onChange={(e) => {
                this.props.categorySelected(e);
                this.props.selectedCategory(e.target.value);
              }}
              disabled={this.props.disabled.category}
              val={this.props.recipeForm.category}
            />
          </Col>
          <Col sm={{ size: 3 }}>
            <Field
              name="size"
              component={RecipePageRecipeFormDropdown}
              options={servingOptions}
              placeholder={t("recipe.SERVING_DROPDOWN_PLACEHOLDER")}
              onChange={this.onSizeChanged}
              disabled={recipeForm.category == "999" ? false : true}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Field
            name="recipe"
            component={VautoComplete}
            placeholder={
              recipeForm.category == "999"
                ? this.props.t("recipe.RECIPE_NAME_TEXT")
                : this.props.t("recipe.RECIPE_NAME_DEFAULT_TEXT")
            }
            //show={this.state.show}
            onChangeText={(val) => {
              this.recipeOnChange(val);
            }}
            onPaste={(val) => {
              this.recipeOnChange(val);
            }}
            onSelect={(e) => {
              this.replaceOrAddRecipe(e);
            }}
            onRecipeNameBlur={() => {
              const val = (this.props.recipeForm && this.props.recipeForm.recipe) || "";
              this.props.commitTypedRecipeName(val);
            }}
            onSuggestStart={this.props.startsearchRecipeOptions}
            onSuggestFinish={this.props.endsearchRecipeOptions}
            val={recipeForm.recipe}
            category={recipeForm.category == "999" ? "02" : recipeForm.category}
            level="000101"
            sType={recipeForm.category == "999" ? "6" : "5"}
            disabled={this.props.disabled.recipe}
            onClear={() => {
              this.recipeOnChange("");
            }}
            showCross={false}
            showHistory={false}
          />
        </FormGroup>
        <FormGroup>
          <Field
            component={InputText}
            type="hidden"
            name="_id"
            placeholder="ID"
          />
          <Field
            component={InputText}
            type="hidden"
            name="user"
            placeholder="user"
          />
        </FormGroup>
        <FormGroup row>
          <Col className={"border-col"}>
            <Field
              component={InputText}
              type="textarea"
              name="comment"
              val={recipeForm.recipe}
              placeholder={t("products.COMMENT_DEFAULT_TEXT")}
              disabled={this.props.disabled.ingredientcomment}
              onChange={this.props.onChangeRecipeForm}
              maxLength={5000}
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

RecipeForm = reduxForm({
  form: "formRecipe",
  enableReinitialize: true,
})(RecipeForm);

RecipeForm = connect((state) => ({
  initialValues: state.recipe.recipeForm,
}))(RecipeForm);

class Recipe extends Component {
  constructor(props) {
    super(props);
    this.AddItemClicked = this.AddItemClicked.bind(this);
    this.ingredientSubmit = this.ingredientSubmit.bind(this);
    this.UpdateItemClicked = this.UpdateItemClicked.bind(this);
    //this.deleteClicked = this.deleteClicked.bind(this);
    this.saveRecipe = this.saveRecipe.bind(this);
    this.SaveOrUpdateClicked = this.SaveOrUpdateClicked.bind(this);
    this.clearRecipe = this.clearRecipe.bind(this);
    this.otherCuisineModal = this.otherCuisineModal.bind(this);
    this.recipeSubmit = this.recipeSubmit.bind(this);
    this.askClearRecipe = this.askClearRecipe.bind(this);
    // this.ingredientUpdatedFunction = this.ingredientUpdatedFunction.bind(this);
    this.submitAfterAsk = this.submitAfterAsk.bind(this);
    this.savedAddItem = this.savedAddItem.bind(this);
    this.categorySelected = this.categorySelected.bind(this);
    this.getRecipe = this.getRecipe.bind(this);
    this.inputFileRef = React.createRef();
    this.addCustomAlert = this.addCustomAlert.bind(this);
    this.state = {
      changedCnt: 1,
      is_saved: 0,
      ingredientValidator: "",
      recipeId: "",
      ingredientsVmodal: false,
      ingredientsVmodalData: "",
      deleteItem: "",
      posunits: undefined,
      selectIdtoEdit: 0,
      appendBarcode: "",
      recipe: {},
      addDuplicateEntry: false,
      incompatibleIngredientName: false,
      barcodeAlert: false,
      barcodeValue: this.props.barcodeValue,
      deleteNotUpdated: false,
      deleteNotAdded: false,
      compressingCount: 0,
    };
    this.saveFlag = false;
    this.idNoProblem = false;
  }
  componentDidMount() {
    // ✅ Call helper that handles Contribution Cancelled for Chrome, Firefox, Safari & Edge
    // Product Not Contributed prompt display and recreate unsavedAlertData 
    this.cleanupPage = SetupPageWithBFCacheAndPrompt(this, {
      promptRefName: "ProductNotContributed",
      initCallback: () => {
        let cat = localStorage.getItem("recipeCat");
        let contDefault = localStorage.getItem("contDefault");
        const defaultData = JSON.parse(contDefault);
        let isBodyMap = localStorage.getItem("bodyreturn") == "recipe";
        let isBodyMapSymptom = localStorage.getItem("bodyMapSymptom");
        let selectedIndex = localStorage.getItem("selectedIndex");

        if (isBodyMap) {
          if (isBodyMapSymptom) {
            this.setState({ selectIdtoEdit: selectedIndex });
            this.props.fromBodyMap(selectedIndex);
          } else {
            localStorage.removeItem("bodystate");
            localStorage.removeItem("bodyreturn");
          }
        } else {
          if (this.props.location.state && this.props.location.state.cat) {
            this.props.categorySelected(this.props.location.state.cat);
          }
          if (cat && cat != null) {
            this.props.categorySelected(cat);
          }

          let id = this.props.location.search.replace("?id=", "");
          this.setState({ recipeId: id || "" });
          this.props.formInitialization(id);
          window.id = id;

          if (id == "" && !defaultData) {
            this.props.clearRecipe();
          } else if (defaultData) {
            this.props.getRecipeDetail(defaultData);
            this.setState({ selectIdtoEdit: defaultData.selectedIndex });
            // localStorage.removeItem("contDefault");
          } else {
            this.props.loadIngredients({ id });
          }
        }

        this.updatePageTitle();
      },
      // NEW: make sure we’re reading the latest storage on restores
      dirtyFlagKey: "previousPageIsDirty",
      onDirtyFlagChange: (exists) => {
        // Optional: if your page keeps any local state/Redux that depends on this flag,
        // clear it here when exists === false.
        // (Most pages don’t need anything here; the normalize step is enough.)
      },
    });
  }

  componentWillUnmount() {
    localStorage.removeItem(SIZE_KEY);
    this.props.clearRecipe();
    if (this.cleanupPage) this.cleanupPage();
  }

  componentDidUpdate(prevProps) {
    const prevCat = prevProps.recipeForm && prevProps.recipeForm.category;
    const currCat = this.props.recipeForm && this.props.recipeForm.category;
    if (prevProps.customRecipe !== this.props.customRecipe || prevCat !== currCat) {
      this.updatePageTitle();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ingredientList && nextProps.ingredientList.length > 1) {
      this.setState({ ingredientValidator: "" });
    }
  }

  checkUnitMeasurement(category, id, upc) {
    if (
      (category !== "07" &&
        category !== "01" &&
        (category === "02" || category === "03" || category === "999") &&
        !id) ||
      category === "04" ||
      category === "05" ||
      category === "06" ||
      ((category === "02" || category === "03" || category === "999") && upc)
    ) {
      return true;
    } else {
      return false;
    }
  }

  posunits(unit, cat) {
    let units = {};
    units.names = "";
    units.ids = [];
    let lsUnits = [];
    if (cat == "01") {
      lsUnits = SYMPTOM_UNITS_NEW();
    } else if (cat == "03") {
      lsUnits = ACTIVITY_UNITS();
    } else if (cat == "04") {
      lsUnits = PCP_UNITS();
    } else if (cat == "999" || cat == "02") {
      lsUnits = FOOD_UNITS();
    } else if (cat == "05") {
      lsUnits = DRUG_UNITS();
    } else if (cat == "06") {
      lsUnits = SUP_UNITS();
    } else if (cat == "07") {
      lsUnits = LOC_UNITS();
    }
    if (cat == "999" || cat == "02") {
      lsUnits.map((item) => {
        if (unit !== "135" && unit !== "125") {
          if (item._id !== "135" && item._id !== "125") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else {
          if (item._id === unit) {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        }
      });
    } else if (cat === "03") {
      lsUnits.map((item) => {
        if (unit === "101" || unit === "102" || unit === "445") {
          if (item._id === "101" || item._id === "102" || item._id === "445") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else if (unit === "103" || unit === "104") {
          if (item._id === "103" || item._id === "104") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else {
          if (item._id === unit) {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        }
      });
    } else {
      lsUnits.map((item) => {
        if (item._id === unit) {
          units.names += item.unit + ", ";
          units.ids.push(item._id);
        }
      });
    }
    units.names = units.names.slice(0, -2);
    return units;
  }

  AddItemClicked() {
    this.setState({
      updateMode: false,
      addDuplicateEntry: false,
      incompatibleIngredientName: false,
    });

    const {
      ingredientForm,
      recipeForm,
      category,
      ingredientList,
      kitData,
      recipeIngredient,
      scaleOptions,
      outOfRange,
    } = this.props;

    const S = (v) => (v == null ? "" : String(v));
    // collapse multiple spaces, trim ends
    const normalizeSpaces = (s) => S(s).replace(/\s+/g, " ").trim();
    // normalized “identity name”: trim, collapse spaces, drop trailing (C)/(R)/(CR)/(CG) (any case/spacing), lower
    const normName = (name) =>
      normalizeSpaces(name).replace(/\s*\((c(r|g)?|r)\)\s*$/i, "").toLowerCase();
    const recipeName = S(recipeForm && recipeForm.recipe);
    const recipeIsRef = recipeName.endsWith("(R)");
    const isKitBased = kitData && kitData.length > 0;
    const isContributedItem = ingredientForm.upc && (!ingredientForm._id || String(ingredientForm._id).slice(0, 1) !== "1");
    const recipeNameWithoutC = normalizeSpaces(recipeForm.recipe).toLowerCase().replace(/\(c(r|g)?\)$/i, "").trim();
    const ingredientNameWithoutC = normalizeSpaces(ingredientForm.recipe_full).toLowerCase().replace(/\(c(r|g)?\)$/i, "").trim();
    const itemID = ingredientForm._id && String(ingredientForm._id).slice(0, 1);
    const isDropdownAmount = Array.isArray(scaleOptions) &&
      scaleOptions.some(opt => String(opt.value) === String(ingredientForm.size));

    const amountValue = isDropdownAmount ? true : checkInput(ingredientForm.size, ingredientForm.unitid);
    const isCustomEntry = !ingredientForm._id && !ingredientForm.upc && !isKitBased;

    // itemKey once: { type: 'id'|'upc'|'name', value }
    const getItemKey = (item) => {
      if (item._id) return { type: "id", value: S(item._id) };
      if (item.upc) return { type: "upc", value: S(item.upc) };
      return { type: "name", value: normName(item.recipe_full || item.recipe) };
    };
    const sameByKey = (a, b) => a.type === b.type && a.value && b.value && a.value === b.value;

    // ---------- working values ----------
    const nowKey = getItemKey(ingredientForm);

    // 🔴 1. Incompatible Ingredient / Hidden Ingredient Prompt
    // 1a) Incompatible Ingredient (non-kit, custom-like item equals recipe name)
    if (
      (itemID === "6" || !itemID) &&
      category === "999" &&
      !recipeIsRef &&
      !isKitBased &&
      !isContributedItem &&
      ingredientNameWithoutC === recipeNameWithoutC
    ) {
      this.incompatibleIngredient.changeStatus(); // 🟠 Prompt: Incompatible Ingredient
      this.setState({ incompatibleIngredientName: true });
      return;
    }

    // 1b) Incompatible Hidden Ingredient (global hidden-name match)
    if (
      category === "999" &&
      Array.isArray(recipeIngredient) &&
      recipeIngredient.some((ing) =>
        (normalizeSpaces(ing.recipe_full).endsWith("(C)") || normalizeSpaces(ing.recipe_full).endsWith("(CR)")) &&
        normName(ing.recipe_full) === recipeNameWithoutC
      )
    ) {
      this.incompatibleIngredient.changeStatus(); // 🟠 Prompt: Incompatible Hidden Ingredient
      return;
    }

    // 1c) Incompatible Hidden Ingredient (kit-based): item in kit equals recipe name
    if (
      category === "999" &&
      Array.isArray(kitData) &&
      isKitBased &&
      kitData.some(item =>
        (item.recipe_full.endsWith("(C)") || item.recipe_full.endsWith("(CR)")) &&
        normName(item.recipe_full) === recipeNameWithoutC
      )
    ) {
      this.incompatibleIngredient.changeStatus(); // 🟠 Prompt: Incompatible Ingredient (Kit-based)
      return;
    }

    // 🔴 2. Incompatible Unit Prompt
    for (const item of ingredientList) {
      const itemKey = getItemKey(item);
      if (sameByKey(nowKey, itemKey)) {
        const validUnits = this.posunits(item.unitid, category);
        if (!validUnits.ids.includes(ingredientForm.unitid)) {
          if (this.checkUnitMeasurement(category, ingredientForm._id, item.upc)) {
            this.setState({ posunits: validUnits.names });
            this.showDuplicateUnit.changeStatus();
            return;
          }
        }
      }
    }

    // 🔴 3. Invalid Value
    if (!amountValue) {
      this.invalidValue.changeStatus(); // 🟠 Prompt: Invalid Value
      return;
    }

    // 🔴 4. Duplicate Entry
    // (a) kitData vs ingredientList\selected
    if (kitData && kitData.length) {
      let isDuplicate = false;
      for (const k of kitData) {
        const kKey = getItemKey(k);
        for (const n of ingredientList) {
          if (sameByKey(kKey, getItemKey(n))) { isDuplicate = true; break; }
        }
        if (isDuplicate) break;
      }
      if (isDuplicate) {
        this.pendingRangeCheckSource = "from duplicate prompt";
        this.pendingRangeCheck = () => {
          if (this.props.outOfRange && this.rangeCheck) {
            this.rangeCheck.changeStatus(); // Trigger value too small/large checking
            return true;
          }
        };

        this.setState({ valertType: "optionUpdate", addDuplicateEntry: true }, () => {
          this.showDuplicateError.changeStatus();
        });
        return false;
      }
    } else {
      // (b) within displayed list (ignore selected row)
      for (let i = 0; i < ingredientList.length; i++) {
        if (sameByKey(nowKey, getItemKey(ingredientList[i]))) {
          this.pendingRangeCheckSource = "from duplicate prompt";
          this.pendingRangeCheck = () => {
            if (this.props.outOfRange && this.rangeCheck) {
              this.rangeCheck.changeStatus(); // Trigger value too small/large checking
              return true;
            }
          };
          this.setState({ valertType: "updateAdd" }, () => {
            this.showDuplicateError.changeStatus();
          });
          return false;
        }
      }
    }


    // 🔴 5. Out of Range (Skip for Food/Recipe category 999)
    if (outOfRange && category !== "999") {
      this.pendingCustomCheck = () => {
        if (isCustomEntry && this.CustomItemNotIn12u12DB) {
          this.CustomItemNotIn12u12DB.changeStatus(ingredientForm);
          return true;
        }
        // this.props.addClicked();
        this.ingredientSubmit();
        return true;
      };

      this.rangeCheck.changeStatus(); // 🟠 Prompt: Value Too Large/Small
      return;
    }

    // 🔴 6. Not in 12u12 Database
    if (isCustomEntry && this.CustomItemNotIn12u12DB) {
      this.CustomItemNotIn12u12DB.changeStatus(ingredientForm); // 🟠 Prompt: Not in 12u12
      return;
    }

    // 🔴 7. Regimen Entry
    if (isKitBased) {
      this.props.IngredientOptionAdded();
      return true;
    }

    // ✅ Final Step: Add Item
    // this.props.addClicked();
    this.ingredientSubmit();
  }

  savedAddItem() {
    this.idNoProblem = true;
    this.ingredientSubmit(this.savedValues);
  }
  ingredientSubmit(values) {
    const { ingredientForm, updateMode, addIngredientItem, saveIngredientItem } = this.props;

    // Use latest form state instead of stale 'values'
    const finalValues = { ...ingredientForm };

    // If needed, perform any final formatting or unit conversions here
    // For example: finalValues.backendScale = ...
    // But skip if already handled earlier

    // Proceed with saving the item
    if (updateMode) {
      saveIngredientItem(finalValues);
    } else {
      addIngredientItem(finalValues);

      // Optional: reset form-specific validations or UI states if required
      this.ingredient.stateChanger("autoIngredientValidator", "");
      this.ingredient.stateChanger("symbolValidator", "");
      this.ingredient.stateChanger("sizeValidator", "");
    }
  }

  submitAfterAsk(values) {
    this.ingredientFromValues = {};
    this.recipeSubmit(this.afterAskValues);
  }
  categorySelected(e) {
    if (this.props.ingredientList && this.props.ingredientList.length > 0) {
      this.RecipeNotSaved.changeStatus();
    } else {
      e = e.target.value;
      this.props.categorySelected(e);
    }
    // e = e.target.value;
    // this.props.categorySelected(e);
    this.catEvent = e;
  }
  catPosClicked() {
    let selectedCat = this.props.selectedCat;
    this.props.categorySelected(selectedCat);
  }
  recipeSubmit() {
    let values = { ...this.props.recipeForm };
    this.ingredientFromValues = undefined;
    if (!this.saveFlag) {
      return;
    }
    this.saveFlag = false;

    const rawName = String(values.recipe || "").trim();

    // 1. Remove trailing legacy "(C)" only
    let normalizedName = rawName.replace(/\s*\(C\)\s*$/i, "").trim();

    // 2. Normalize legacy no-space CR/CG markers at the end:
    //    Recipe A(CR)            -> Recipe A (CR)
    //    Recipe A(CR) - Shared   -> Recipe A (CR) - Shared
    //    Recipe A(CG)            -> Recipe A (CG)
    normalizedName = normalizedName
      .replace(/\(CR\)(\s*-\s*Shared(?:\s+\d+)?)?$/i, " (CR)$1")
      .replace(/\(CG\)(\s*-\s*Shared(?:\s+\d+)?)?$/i, " (CG)$1")
      .replace(/\s+/g, " ")
      .trim();

    // 3. Detect whether canonical marker already exists
    const hasCR = /\s\(CR\)(?:\s*-\s*Shared(?:\s+\d+)?)?$/i.test(normalizedName);
    const hasCG = /\s\(CG\)(?:\s*-\s*Shared(?:\s+\d+)?)?$/i.test(normalizedName);

    let recipeNameToSave = normalizedName;

    if (values.category == "999") {
      if (!hasCR) {
        recipeNameToSave = `${normalizedName} (CR)`;
      }
    } else {
      if (!hasCG) {
        recipeNameToSave = `${normalizedName} (CG)`;
      }
    }

    let data = {};
    var validationFlag = true;

    if (values.category == "999") {
      let ingredients = (this.props.ingredientList || []).map((ing) => {
        const id = ing && ing._id ? String(ing._id) : "";
        const upc = ing && ing.upc ? String(ing.upc) : null;
        const name = ing.recipe_full ? ing.recipe_full : ing.recipe;

        return {
          _id: id,
          recipe: name,
          recipe_full: name,
          unitid: ing.unitid,
          original_size: ing.original_size,
          size: ing.size,
          units: ing.units,
          ...(upc ? { upc } : {}),
          // full_name: name,
          // fullname: name,
          // recipes: name,
          // unitList: ing.units,
          // ingredients_text: ing.ingredients_text,
        };
      })
      // console.log("ingredients", ingredients)

      data = {
        recipe: recipeNameToSave,
        cuisine: values.cuisine,
        user: values.user,
        size: values.size,
        comment: values.comment,
        ingredients: ingredients,
        duplicate: false,
        category: values.category,
      };
    } else {
      let items = (this.props.ingredientList || []).map((item) => {
        const id = item && item._id ? String(item._id) : "";                  // <-- always present
        const upc = item && item.upc ? String(item.upc) : null;                // omit if falsy
        const name = item.recipe_full ? item.recipe_full : item.recipes;

        return {
          _id: id,
          name: name,
          unit: item.backendUnit || item.unitid,
          value: item.backendSize || item.size,
          ...(upc ? { upc } : {}),
        };
      });

      // Build WITHOUT _id
      data = {
        name: recipeNameToSave,
        comment: values.comment,
        items: items,
        category: values.category,
      };
    }

    // --------- Decide which _id (if any) to send ----------
    // 1) Backend-provided exact match ALWAYS wins
    const backendExactId = this.props.exactExistRecipeId;

    // 2) Otherwise include form _id ONLY for custom types
    const allowFormId = (this.props.customRecipe || this.props.customItem) && !!values._id;

    const finalId = backendExactId || (allowFormId ? values._id : undefined);
    if (finalId) data._id = finalId; // omit _id entirely for RefDB

    if (!validationFlag) return;
    setTimeout(() => {
      // if (values._id) {
      //   data._id = values._id;
      // }
      // ⛔️ Do NOT re-add values._id here — it breaks the rule.
      this.props.saveRecipe(
        data,
        () => { this.state.is_saved = 1; },
        this.props.exactExistRecipeId // keep passing if your service expects it
      );
    }, 300);
  }

  ingredientItemOnClick = (index) => {
    // keep both for follow-up actions / valert positiveAction
    this.setState({ selectIdtoEdit: index, addDuplicateEntry: false });
    this.clickedIndex = index;

    const {
      ingredientSelected,
      ingredientForm,
      ingredientList,
      selectedIndex,
      itemChanged,
    } = this.props;

    // ── Selection state
    const isSelected = !!ingredientSelected && !_.isEmpty(ingredientSelected);

    // ── Has the selected row changed (and thus needs Update)?
    const formChanged =
      isSelected &&
      (
        itemChanged ||
        (ingredientForm && ingredientSelected && ingredientForm.recipe_full !== ingredientSelected.recipe_full)
      );

    // ── “New item in form” (user typed name/UPC but didn’t add)
    const formHasNameOrUPC =
      ingredientForm &&
      (
        (ingredientForm.recipe_full && ingredientForm.recipe_full.trim() !== "") ||
        (ingredientForm.upc && ingredientForm.upc.trim() !== "")
      );

    const isNewItem = !isSelected && formHasNameOrUPC;

    // ───────────────────────────────
    // 🧠 Prompt decision logic
    // ───────────────────────────────

    if (isSelected && formChanged) {
      // Case 1: Editing the selected row and trying to select another (or deselect the same)
      this.CurrentItemNotUpdated.changeStatus();
      return;
    }

    if (isNewItem) {
      // Case 2 & 3: New item present in form (complete or incomplete)
      // NewItemPending Valert in rendered with different title/text depending on addBtn
      this.NewItemPending.changeStatus();
      return;
    }

    // Case 4: Safe — toggle selection/deselection via reducer
    const ingredient = ingredientList[index];
    this.props.editIngredientItem(index);
  };

  posClicked = () => {
    const { ingredientList } = this.props;
    const ingredient = ingredientList[this.clickedIndex];

    // reducer will toggle select/deselect and reset the form
    this.props.editIngredientItem(this.clickedIndex);
  };


  UpdateItemClicked = () => {
    const {
      kitData,
      ingredientList,
      selectedIndex,
      recipeForm,
      ingredientForm,
      category,
      outOfRange,
      scaleOptions,
      recipeIngredient,
    } = this.props;

    // ---------- helpers ----------
    const S = (v) => (v == null ? "" : String(v));
    // collapse multiple spaces, trim ends
    const normalizeSpaces = (s) => S(s).replace(/\s+/g, " ").trim();
    // normalized “identity name”: trim, collapse spaces, drop trailing (C)/(R)/(CR)/(CG) (any case/spacing), lower
    const normName = (name) =>
      normalizeSpaces(name).replace(/\s*\((c(r|g)?|r)\)\s*$/i, "").toLowerCase();

    const recipeName = S(recipeForm && recipeForm.recipe);
    const recipeIsRef = recipeName.endsWith("(R)");
    const isKitBased = kitData && kitData.length > 0;
    const isContributedItem = ingredientForm.upc && (!ingredientForm._id || String(ingredientForm._id).slice(0, 1) !== "1");
    const recipeNameWithoutC = normalizeSpaces(recipeForm.recipe).toLowerCase().replace(/\(c(r|g)?\)$/i, "").trim();
    const ingredientNameWithoutC = normalizeSpaces(ingredientForm.recipe_full).toLowerCase().replace(/\(c(r|g)?\)$/i, "").trim();
    const itemID = ingredientForm._id && String(ingredientForm._id).slice(0, 1);
    const isDropdownAmount = Array.isArray(scaleOptions) &&
      scaleOptions.some(opt => String(opt.value) === String(ingredientForm.size));
    const amountValue = isDropdownAmount ? true : checkInput(ingredientForm.size, ingredientForm.unitid);

    const isCustomEntry = !ingredientForm._id && !ingredientForm.upc && !isKitBased;

    // itemKey once: { type: 'id'|'upc'|'name', value }
    const getItemKey = (item) => {
      if (item._id) return { type: "id", value: S(item._id) };
      if (item.upc) return { type: "upc", value: S(item.upc) };
      return { type: "name", value: normName(item.recipe_full || item.recipe) };
    };
    const sameByKey = (a, b) => a.type === b.type && a.value && b.value && a.value === b.value;

    // Short incompatible-unit check (like Add): only against items matching by key
    const incompatibleUnitPrompt = (key, unitid) => {
      for (const item of ingredientList) {
        if (item.isSelected) continue;
        const itemKey = getItemKey(item);
        if (!sameByKey(key, itemKey)) continue;

        const varunit = this.posunits(item.unitid, category);
        if (!varunit.ids.includes(unitid) && this.checkUnitMeasurement(category, ingredientForm._id, item.upc)) {
          this.setState({ posunits: varunit.names });
          this.showDuplicateUnit.changeStatus();
          return true; // blocked
        }
      }
      return false;
    };

    // ---------- working values ----------
    const before = (ingredientList && ingredientList[selectedIndex]) || {};
    // Use the same “key-first” comparison you use elsewhere: id → upc → normalized name
    const beforeKey = getItemKey(before);     // { type: 'id'|'upc'|'name', value }
    const nowKey = getItemKey(ingredientForm); // { type: 'id'|'upc'|'name', value }
    const hasNameChanged = !sameByKey(beforeKey, nowKey);

    const isAlreadyInDisplayArea = ingredientList.some((it, i) =>
      i !== selectedIndex && sameByKey(getItemKey(it), nowKey)
    );

    // ---------- early guards (same as Add style) ----------
    this.setState({ incompatibleIngredientName: false, addDuplicateEntry: false });

    // 1a) Incompatible Ingredient (non-kit, custom-like item equals recipe name)
    if (
      (itemID === "6" || !itemID) &&        // custom-like: id starts with 6 OR no id, and no upc
      category === "999" &&
      !recipeIsRef &&
      !isKitBased &&
      !isContributedItem &&
      ingredientNameWithoutC === recipeNameWithoutC // ingredient name equals recipe name
    ) {
      this.incompatibleIngredient.changeStatus(); // 🟠 Prompt: Incompatible Ingredient
      this.setState({ incompatibleIngredientName: true });
      return;
    }

    // 1b) Incompatible Hidden Ingredient (global hidden-name match)
    if (
      category === "999" &&
      Array.isArray(recipeIngredient) &&
      recipeIngredient.some((ing) =>
        (normalizeSpaces(ing.recipe_full).endsWith("(C)") || normalizeSpaces(ing.recipe_full).endsWith("(CR)")) &&
        normName(ing.recipe_full) === recipeNameWithoutC
      )
    ) {
      this.incompatibleIngredient.changeStatus(); // 🟠 Prompt: Incompatible Hidden Ingredient
      return;
    }

    // 1c) Incompatible Hidden Ingredient (kit-based): item in kit equals recipe name
    if (
      category === "999" &&
      Array.isArray(kitData) &&
      isKitBased &&
      kitData.some(item =>
        (item.recipe_full.endsWith("(C)") || item.recipe_full.endsWith("(CR)")) &&
        normName(item.recipe_full) === recipeNameWithoutC
      )
    ) {
      this.incompatibleIngredient.changeStatus(); // 🟠 Prompt: Incompatible Ingredient (Kit-based)
      return;
    }

    // ---------- 2) Incompatible unit group (short form) ----------
    if (incompatibleUnitPrompt(nowKey, ingredientForm.unitid)) return false;


    // ---------- 3) Invalid Value ----------
    if (!amountValue) {
      this.invalidValue.changeStatus(); // 🟠 Prompt: Invalid Value
      return;
    }

    // ---------- 4) Duplicate checks (ONLY if name actually changed) ----------
    if (hasNameChanged) {
      // (a) kitData vs ingredientList\selected
      if (kitData && kitData.length) {
        const listMinusSel = ingredientList.filter((_, i) => i !== selectedIndex);
        let isDuplicate = false;
        for (const k of kitData) {
          const kKey = getItemKey(k);
          for (const n of listMinusSel) {
            if (sameByKey(kKey, getItemKey(n))) { isDuplicate = true; break; }
          }
          if (isDuplicate) break;
        }
        if (isDuplicate) {
          this.pendingRangeCheckSource = "from duplicate prompt";
          this.pendingRangeCheck = () => {
            if (this.props.outOfRange && this.rangeCheck) {
              this.rangeCheck.changeStatus(); // Trigger value too small/large checking
              return true;
            }
          };

          this.setState({ valertType: "optionUpdate", addDuplicateEntry: false }, () => {
            this.showDuplicateError.changeStatus();
          });
          return false;
        }
      } else {
        // (b) within displayed list (ignore selected row)
        for (let i = 0; i < ingredientList.length; i++) {
          if (i === selectedIndex) continue;
          if (sameByKey(nowKey, getItemKey(ingredientList[i]))) {
            this.pendingRangeCheckSource = "from duplicate prompt";
            this.pendingRangeCheck = () => {
              if (this.props.outOfRange && this.rangeCheck) {
                this.rangeCheck.changeStatus(); // Trigger value too small/large checking
                return true;
              }
            };
            this.setState({ valertType: "updateAdd" }, () => {
              this.showDuplicateError.changeStatus();
            });
            return false;
          }
        }
      }
    }

    // ---------- 5) Out-of-range ----------
    if (outOfRange && category !== "999") {
      this.pendingCustomCheck = () => {
        if (hasNameChanged && isCustomEntry && !isAlreadyInDisplayArea) {
          this.CustomItemNotIn12u12DB.changeStatus(ingredientForm);
          return true;
        }
        // this.props.addClicked();
        this.props.saveClicked();
        return true;
      };
      this.rangeCheck.changeStatus(); // 🟠 Prompt: Value Too Large/Small
      return;
    }

    // ---------- 6) CustomItemNotIn12u12DB (last; only if name changed & not already in display) ----------
    if (hasNameChanged && isCustomEntry && !isAlreadyInDisplayArea) {
      this.CustomItemNotIn12u12DB.changeStatus(ingredientForm);
      return false;
    }

    // ---------- 7) Regimen Entry ----------
    if (isKitBased && hasNameChanged) {
      this.props.IngredientOptionUpdated(this.state.selectIdtoEdit);
      return true;
    }

    this.props.saveClicked();
    return true;
  };

  saveRecipe() {
    this.props.saveRecipe();
  }

  SaveOrUpdateClicked = () => {
    const {
      ingredientForm,
      ingredientSelected,
      disabled,
      category,
      itemChanged,
      cancelMode,
      UpdateHistoricalData,
      customRecipe,
      customItem,
      recipeForm,
    } = this.props;

    // ---- quick booleans ----
    const isSelected = !_.isEmpty(ingredientSelected);
    const idStr = ((recipeForm && recipeForm._id) ? String(recipeForm._id) : "").trim();
    const isExistingCustomItem = !!idStr && idStr.startsWith("6") && !!customItem;

    const addEnabled = !disabled.addBtn;   // your flags use "disabled.*"
    const addDisabled = !!disabled.addBtn;

    // "has something in the form" = name or upc present
    const formHasNameOrUPC =
      ingredientForm &&
      (
        (ingredientForm.recipe_full && ingredientForm.recipe_full.trim() !== "") ||
        (ingredientForm.upc && ingredientForm.upc.trim() !== "")
      );

    // New vs Selected
    const isNewItem = !isSelected && formHasNameOrUPC;

    // 1) Incomplete last ingredient/item: user filled the field(s) but it's incomplete → Add disabled
    if (isNewItem && addDisabled) {
      this.IncompleteLastItem.changeStatus();
      return;
    }

    // 2) Last ingredient/item not added: fields completely filled, but user didn't press Add
    if (isNewItem && addEnabled) {
      this.LastItemNotAdded.changeStatus();
      return;
    }

    // 3) Selected item not updated: row selected, it's eligible to Update, but user didn't press Update
    if (isSelected && addEnabled && !cancelMode) {
      this.SelectedItemNotUpdated.changeStatus();
      return;
    }

    // 4) Incomplete change to selected item: row selected, changes made, but not all required fields filled
    if (isSelected && itemChanged && cancelMode) {
      this.IncompleteChangeToSelectedItem.changeStatus();
      return;
    }

    // 5) Using Existing Custom Item as Recipe Name → ask user first
    if (category === "999" && isExistingCustomItem) {
      this.UpdateCustomItem.changeStatus();
      return;
    }

    // 6) Recipe-level: user made recipe-level changes
    if (category === "999" && UpdateHistoricalData) {
      this.UpdateHistoricalData.changeStatus();
      return;
    }

    // 7) All good → save
    this.props.saveClickedRecipe();
    this.saveFlag = true;
  };

  submit() {
    const { recipeForm, customItem, UpdateHistoricalData } = this.props;

    const category = recipeForm && recipeForm.category;
    const idStr = recipeForm && recipeForm._id ? String(recipeForm._id).trim() : "";
    const isExistingCustomItem =
      category === "999" &&
      !!idStr &&
      idStr.startsWith("6") &&
      !!customItem;
    
    // ✅ Re-check custom-item prompt when save flow comes here
    if (isExistingCustomItem) {
      this.UpdateCustomItem.changeStatus();
      return;
    }

    if (this.props.category === "999" && UpdateHistoricalData) {
      this.UpdateHistoricalData.changeStatus();
    } else if (!UpdateHistoricalData) {
      this.updateRecipePos();
    } else {
      this.recipeSubmit();
    }
  }
  updateRecipePos() {
    this.saveFlag = true;
    this.props.saveClickedRecipe();
  }
  askClearRecipe() {
    this.clearValert.changeStatus();
  }
  clearRecipe() {
    window.location.reload();
    if (this.state.recipeId) {
      window.location = "/recipe";
      localStorage.removeItem("recipePageTitle");
    }
    this.props.clearRecipe();
    localStorage.removeItem("recipeCat");
    this.recipe.stateChanger("autoRecipeValidator", "");
    this.recipe.stateChanger("cuisineValidator", "");
    this.setState({ ingredientValidator: "" });
    this.ingredient.stateChanger("autoIngredientValidator", "");
    this.ingredient.stateChanger("symbolValidator", "");
    this.ingredient.stateChanger("sizeValidator", "");
  }

  otherCuisineModal(e) {
    const cuisineName = window.prompt(this.props.t("recipe.NEW_CUISINE_TEXT"));

    if (cuisineName) {
      const cuisineObj = { cuisine: cuisineName };
      this.props.createCuisine(cuisineObj);
    } else {
      e.preventDefault();
      return false;
    }
  }
  ingredientsModalHandler(title, ingredients_text) {
    let returnHTml = (
      <div className="ingredientsAreaInMealPlanner">
        <h4>{title}</h4>
        <ul>
          <span style={{ fontWeight: 500 }}>
            {this.props.t("symptoms.INGREDIENT_TEXT")}
          </span>
          <span style={{ fontSize: 14, color: "#333" }}>
            {ingredients_text}
          </span>
        </ul>
      </div>
    );

    this.setState({
      ingredientsVmodal: true,
      ingredientsVmodalData: returnHTml,
    });
  }
  getPreviousPageType() {
    const { recipeForm, recipeId } = this.props;
    if (recipeId || recipeForm._id) {
      return recipeForm.category === "999" ? "editRecipe" : "editRegimen";
    } else {
      return recipeForm.category === "999" ? "createRecipe" : "createRegimen";
    }
  }
  bodyMapClicked() {
    if (!_.isEmpty(this.props.ingredientSelected)) {
      localStorage.setItem("selectedIndex", this.props.selectedIndex);
    }
    if (!this.props.disabled.saveBtn) {
      sessionStorage.setItem("previousPageIsDirty", this.getPreviousPageType()); // Set previousPageIsDirty if Save or Update Regimen/Recipe button is enabled. Get the appropriate page title from "getPreviousPageType"
    }
    this.props.bodyMapClicked();
  }
  afterSaved() {
    this.props.history.push("/");
  }
  barcodeAlert = () => {
    this.barcodeAlertStatus.changeStatus();
  };
  barcodeImageAlert() {
    // this.barcodeAlertStatus.changeStatus();
    this.inputFileRef.current.click();
  }
  // submitUpcImage(image) {
  //   this.props.onSubmitUpcImage(
  //     image,
  //     this.props.recipeForm.category && this.props.recipeForm.category == "999"
  //       ? "02"
  //       : this.props.recipeForm.category
  //   );
  // }
  async submitUpcImage(image) {
    if (!image) return;

    this.startCompress();
    let fileToSend = image;
    try {
      // fileToSend = image.size > 1000000 ? await compressImageSmart(image) : image;

      // 1) Only compress when > 1MB (your existing helper)
      if (fileToSend.size > 1000000) {
        fileToSend = await compressImageSmart(fileToSend);
      }

      // 2) Always sanitize-encode (avoid WAF/ALB false positives)
      fileToSend = await sanitizeEncodeImage(fileToSend, {
        mimeType: "image/jpeg",
        quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
        maxDim: 2048,
      });

      console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

    } finally {
      this.endCompress();
    }

    this.props.onSubmitUpcImage(
      fileToSend,
      this.props.recipeForm.category && this.props.recipeForm.category == "999"
        ? "02"
        : this.props.recipeForm.category
    );
  }

  startCompress = () =>
    this.setState(s => ({
      compressingCount: s.compressingCount + 1
    }));

  endCompress = () =>
    this.setState(s => {
      const next = Math.max(0, s.compressingCount - 1);
      return { compressingCount: next };
    });

  addBarcodeToField() {
    const {
      upc404,
      upc404Value,
      ingredientList,
      recipeForm,
      ingredientForm,
      selectedIndex,
      ingredientSelected,
      duplicateList,
      recipeFormValue,
      customRecipe,
      getRecipe,
      RefDbRecipe,
    } = this.props;
    this.setState({
      appendBarcode: upc404,
    });
    let contDefault = {
      page: "recipe",
      barcode: upc404Value,
      category: recipeForm.category == "999" ? "02" : recipeForm.category,
      ingredientList,
      recipeForm,
      ingredientForm,
      selectedIndex,
      ingredientSelected,
      duplicateList,
      recipeFormValue,
      customRecipe,
      getRecipe,
      RefDbRecipe,
    };
    let defaultVal = JSON.stringify(contDefault);
    localStorage.setItem("contDefault", defaultVal);
  }
  onBarcodeSearch = () => {
    this.props.barcodeSearch(
      this.state.barcode,
      this.props.recipeForm.category
    );
    this.setState({ barcodeValue: this.state.barcode });
    this.setState({ barcode: "" });
  };
  getRecipe(val) {
    this.setState({ recipe: val });
  }
  addCustomAlert() {
    this.props.searchIngredientOptions("", true);
    this.addCustomVAlert.changeStatus();
  }
  DeleteIconClicked(e, item, index) {
    e.stopPropagation();

    // keep both around: _id for UI, index for reducer delete
    this.setState({ deleteItem: item._id });
    this.deleteItem = index;

    const { ingredientSelected, ingredientForm, selectedIndex, itemChanged } = this.props;

    // Selection state
    const isSelected = !!ingredientSelected && !_.isEmpty(ingredientSelected);
    const isSameItem = selectedIndex === index;

    const formChanged =
      isSelected &&
      (
        itemChanged ||
        (ingredientForm && ingredientSelected && ingredientForm.recipe_full !== ingredientSelected.recipe_full)
      );

    const formHasNameOrUPC =
      ingredientForm &&
      (
        (ingredientForm.recipe_full && ingredientForm.recipe_full.trim() !== "") ||
        (ingredientForm.upc && ingredientForm.upc.trim() !== "")
      );

    const isNewItem = !isSelected && formHasNameOrUPC;

    // Case 1: User editing selected item and tries to delete a different item → deleteNotUpdated
    if (isSelected && formChanged && !isSameItem) {
      this.setState({
        deleteNotUpdated: true,
        deleteNotAdded: false,
      });
    }
    // Case 2: User filling form for new item, but tries to delete an item from Display Area → deleteNotAdded
    else if (isNewItem) {
      this.setState({
        deleteNotUpdated: false,
        deleteNotAdded: true,
      });
    }
    // Case 3: Otherwise → show normal delete confirmation
    else {
      this.setState({
        deleteNotUpdated: false,
        deleteNotAdded: false,
      });
    }

    this.deleteValert.changeStatus();
  }
  addIngredientItem(values) {
    const { ingredientForm, ingredientSelected } = this.props;
    values = this.props.ingredientForm;
    const { recipe } = values;
    let newValue = values.recipe;
    this.props.ingredientOptions.forEach((item) => {
      if (item && item.toLowerCase().trim() == recipe.toLowerCase().trim()) {
        newValue = item;
      }
    });

    this.props.addIngredientItem(this.props.ingredientForm);
  }

  addGreyUPC = () => {
    let contDefault = JSON.parse(localStorage.getItem("contDefault"));
    if (contDefault && contDefault.barcode) {
      this.props.addGreyUPCToItemNameField(contDefault.barcode);
      this.props.searchIngredientOptions("", false, true); // Do not clear UPC
      localStorage.removeItem("contDefault"); // ✅ Clear after clicking Continue button
      localStorage.removeItem("unContributed");
    }
  };

  getPageTitle() {
    const { customRecipe, recipeForm, t } = this.props;
    const isRecipe = (recipeForm && recipeForm.category) === "999";

    if (customRecipe) {
      // Edit
      return isRecipe
        ? t("recipe.EDIT_RECIPE_PAGE_TITLE")
        : t("recipe.EDIT_REGIMEN_PAGE_TITLE");
    } else {
      // Create
      return isRecipe
        ? t("recipe.CREATE_RECIPE_PAGE_TITLE")
        : t("recipe.CREATE_REGIMEN_PAGE_TITLE");
    }
  }

  updatePageTitle = () => {
    const title = this.getPageTitle(); // you already added this
    localStorage.setItem("recipePageTitle", title);
    window.dispatchEvent(                   // notify any header listener to re-render
      new CustomEvent("recipe-title-updated", { detail: title })
    );
  };

  render() {
    let {
      isLoading,
      measurementOptions,
      scaleOptions,
      cuisineOptions,
      ingredientList,
      ingredientSelected,
      isEditing,
      ingredientOptions,
      searchIngredientOptions,
      searchRecipeOptions,
      recipeOptions,
      t,
      classNames,
      disabled,
      onChangeIngredientForm,
      onChangeRecipeForm,
      amountReseter,
      amounNewValue,
      replaceItemsAdded,
      IngredientOptionSelected,
      updateMode,
      ingredientForm,
      recipeForm,
      cancelMode,
      incompatibleIngredient,
      alreadyUsedRecipeName,
      alreadyUsedRecipeNameInContent,
      incompatibleHiddenIngredient,
      hiddenIngredientList,
      excessiveNestedRecipe,
      startsearchRecipeOptions,
      endsearchRecipeOptions,
      commitTypedRecipeName,
    } = this.props;
    let isShowSaveIngredient = false;
    if (
      isEditing &&
      this.props.formRecipeIngredient &&
      this.props.formRecipeIngredient.initial !=
      this.props.formRecipeIngredient.values
      //&& this.props.formRecipeIngredient.active
    ) {
      isShowSaveIngredient = true;
    }
    var _pageFitter, _btnFontSize;
    return (
      <div className="vPage mealPlannerPage flex recipe-modern">
        {/*Show loading icon whenever Redux is loading OR we’re compressing:*/}
        <Loading isLoading={isLoading || this.state.compressingCount > 0} />
        <input
          style={{ display: "none" }}
          // key={this.state.barcodeKey || ""}
          type="file"
          name="file"
          id="upc-img"
          ref={this.inputFileRef}
          accept="image/*"
          multiple={false}
          onChange={(e) => {
            e.preventDefault();
            e.target.files && e.target.files.length > 0
              ? this.submitUpcImage(e.target.files[0])
              : null;
          }}
          onClick={(e) => (e.target.value = null)}
        />
        <Vmodal
          displayStatus={this.props.saveSuccess}
          data={
            <div>
              <h4>{t("general.SAVE_SUCCESSFULLY_TITLE")}</h4>
              <p>
                {this.props.recipeForm.category === "999"
                  ? t("recipe.SAVE_RECIPE_TEXT")
                  : t("recipe.SAVE_REGIMEN_TEXT")}
              </p>
            </div>
          }
          closeFunc={() => {
            localStorage.setItem("defaultRecipeManagmentSorting", "rank");
            localStorage.setItem(
              "defaultRecipeManagmentCat",
              this.props.recipeForm.category
            );
            window.location.href = "/recipemanagement";
          }}
          timedClose={2000}
        />
        <Vmodal
          zIndex={11}
          displayStatus={this.state.ingredientsVmodal}
          data={this.state.ingredientsVmodalData}
          closeFunc={() => {
            this.setState({
              ingredientsVmodal: false,
              ingredientsVmodalData: "",
            });
          }}
        />
        <Valert
          display={this.props.barcodeCategory}
          onRef={(ref) => (this.barcodeCategory = ref)}
          title={this.props.t("symptoms.INCORECT_CATEGORY_TITLE")}
          question={t("symptoms.INCORECT_CATEGORY_TEXT")}
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.barcodeVerification = ref)}
          title={t("symptoms.BARCODE_VERIFICATION_TITLE")}
          question={t("symptoms.BARCODE_VERIFICATION_TEXT")}
          positiveAction={() => {
            this.addBarcodeToField();
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.barcodeFailed}
          onRef={(ref) => (this.barcodeFailed = ref)}
          title={t("BARCODE.BARCODE_ERROR_TITLE")}
          question={t("BARCODE.BARCODE_ERROR_TEXT")}
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          title={this.props.t("general.ENTER_BARCODE")}
          // question={"Type your barcode below"}
          onRef={(ref) => (this.barcodeAlertStatus = ref)}
          inputField={true}
          inputType={"number"}
          showInvalid={false}
          positiveAction={this.onBarcodeSearch}
          inputValue={this.state.barcode}
          onChangeInput={(e) => this.setState({ barcode: e.target.value })}
          positiveText={this.props.t("general.SUBMIT")}
          negativeText={this.props.t("general.CANCEL")}
          negativeAction={() => this.setState({ barcode: "" })}
          okBtn={
            this.state.barcode && this.state.barcode.length > 3 ? false : true
          }
        />
        <Valert
          display={false}
          onRef={(ref) => (this.showDuplicateUnit = ref)}
          title={t("symptoms.MEASUREMENT_UNIT_PROMPT_TITLE")}
          question={
            t("symptoms.CHOOSE_UNIT_PROMPT_TEXT") + this.state.posunits + "."
          }
          positiveAction={() => {
            this.setState({ posunits: undefined });
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.incompatibleIngredient = ref)}
          title={
            this.state.incompatibleIngredientName
              ? t("recipe.INCOMPATIBLE_INGREDIENT_TITLE")
              : t("recipe.INCOMPATIBLE_HIDDEN_INGREDIENT_TITLE")
          }
          question={
            this.state.incompatibleIngredientName
              ? t("recipe.INCOMPATIBLE_INGREDIENT_TEXT")
              : t("recipe.INCOMPATIBLE_HIDDEN_INGREDIENT_TEXT")
          }
          positiveAction={() => {
            this.setState({ incompatibleIngredientName: false });
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={incompatibleHiddenIngredient}
          title={t("recipe.INCOMPATIBLE_HIDDEN_INGREDIENT_TITLE")}
          question={
            <div>
              {t("recipe.HIDDEN_INGREDIENT_TEXT")}
              <br />
              {`\u2022 ${t("recipe.RECIPE_TO_SAVE")}: ${recipeForm.recipe}`}
              {hiddenIngredientList.map((item) => (
                <p style={{ marginTop: 10, lineHeight: 1 }}>{`\u2022 ${t(
                  "recipe.INCOMPATIBLE_INGREDIENT_TITLE"
                )}: ${item}`}</p>
              ))}
              {t("recipe.HIDDEN_INGREDIENT_TEXT_1")}
            </div>
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={excessiveNestedRecipe}
          title={t("recipe.EXCESSIVE_NESTED_RECIPE_TITLE")}
          question={
            <div>
              {t("recipe.EXCESSIVE_NESTED_RECIPE_TEXT")}
              {hiddenIngredientList.map((item) => (
                <p
                  style={{ marginTop: 10, lineHeight: 1 }}
                >{`\u2022 ${item}`}</p>
              ))}
            </div>
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.incompatibleName}
          title={t("recipe.INCOMPATIBLE_NAME_TITLE")}
          question={
            <span>
              {t("recipe.INCOMPATIBLE_NAME_TEXT")}
              <span style={{ textTransform: "lowercase" }}>
                {t("recipe.RECIPE_NAME_DEFAULT_TEXT")}
              </span>
              <span>{t("general.FULL_STOP")}</span>
            </span>
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />

        <Valert
          display={this.props.itemInVerAutofill}
          onRef={(ref) => (this.itemInVerAutofillRef = ref)}
          title={t("symptoms.ITEM_IN_VERIFICATION_TITLE")}
          question={t("symptoms.ITEM_IN_VERIFICATION_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.IngredientOptionSelected(this.props.itemData);

            this.props.onChangeAlertStatus({
              itemInVerAutofill: false,
            });

          }}
          readOnly={true}
        />
        <Valert
          display={false}
          title={t("general.OUT_RANGE_AMOUNT_TITLE")}
          question={
            this.props.category === "01"
              ? t("general.OUT_RANGE_SEVERITY_SYMPTOM_TEXT")
              : t("general.OUT_RANGE_SEVERITY_TEXT")
          }
          onRef={(ref) => (this.rangeCheck = ref)}
          positiveAction={() => {
            if (this.pendingCustomCheck && typeof this.pendingCustomCheck === "function") {
              const handled = this.pendingCustomCheck();
              this.pendingCustomCheck = null;
              if (handled) return; // stop if we fully handled the next step
            }

            updateMode ? this.props.saveClicked() : this.ingredientSubmit();
          }}
        />
        <Valert
          display={this.props.alreadyExistRecipeName}
          title={this.props.t("recipe.UPDATE_RECIPE_PROMPT_TITLE")}
          question={this.props.t("recipe.UPDATE_RECIPE_PROMPT_TEXT")}
          onRef={(ref) => (this.UpdateHistoricalData = ref)}
          positiveAction={() => this.updateRecipePos()}
          negativeAction={() => this.props.resetId()}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("recipe.UPDATE_CUSTOM_ITEM_PROMPT_TITLE")}
          question={this.props.t("recipe.UPDATE_CUSTOM_ITEM_PROMPT_TEXT")}
          onRef={(ref) => (this.UpdateCustomItem = ref)}
          positiveAction={() => this.updateRecipePos()}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("general.CURRENT_ITEM_TITLE")}
          question={this.props.t("general.CURRENT_ITEM_TEXT")}
          onRef={(ref) => (this.CurrentItemNotUpdated = ref)}
          positiveAction={() => this.posClicked()}
          negativeAction={() => {
            this.setState({ selectIdtoEdit: this.props.selectedIndex });
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            !this.props.disabled.addBtn
              ? this.props.t("general.NEW_ITEM_TITLE")
              : this.props.t("recipe.INCOMPLETE_NEW_ITEM_TITLE")
          }
          question={
            !this.props.disabled.addBtn
              ? this.props.t("general.NEW_ITEM_TEXT")
              : this.props.t("recipe.INCOMPLETE_NEW_ITEM_TEXT")
          }
          onRef={(ref) => (this.NewItemPending = ref)}
          positiveAction={() => this.posClicked()}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            this.props.recipeForm.category == "999"
              ? this.props.t("recipe.RECIPE_NOT_SAVED_TITLE")
              : this.props.t("recipe.REGIMEN_NOT_SAVED_TITLE")
          }
          question={
            this.props.recipeForm.category == "999"
              ? this.props.t("recipe.RECIPE_CHANGE_CATEGORY_TEXT")
              : this.props.t("recipe.REGIMEN_CHANGE_CATEGORY_TEXT")
          }
          onRef={(ref) => (this.RecipeNotSaved = ref)}
          positiveAction={() => this.catPosClicked()}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            this.state.deleteNotUpdated
              ? t("general.CURRENT_ITEM_TITLE")
              : this.state.deleteNotAdded
                ? t("general.NEW_ITEM_TITLE")
                : t("general.DELETE_CONFIRMATION_TITLE")
          }
          question={
            this.state.deleteNotUpdated
              ? t("general.CURRENT_ITEM_DELETE_TEXT")
              : this.state.deleteNotAdded
                ? t("general.NEW_ITEM_DELETE_TEXT")
                : t("general.DELETE_CONFIRMATION_TEXT")
          }
          onRef={(ref) => (this.deleteValert = ref)}
          positiveAction={() => {
            this.props.deleteIngredientItem(this.deleteItem);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />

        <Valert
          display={false}
          title={this.props.t("general.SELECTED_ITEM_TITLE")}
          question={
            this.props.category === "999"
              ? this.props.t("general.SELECTED_RECIPE_ITEM_TEXT")
              : this.props.t("general.SELECTED_ITEM_TEXT")
          }
          onRef={(ref) => (this.SelectedItemNotUpdated = ref)}
          positiveAction={() =>
            this.props.category === "999"
              ? this.submit()
              : this.updateRecipePos()
          }
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("symptoms.OTHER_ENTRY_ERROR_TITLE")}
          question={t("symptoms.OTHER_ENTRY_ERROR_TEXT")}
          onRef={(ref) => (this.CustomItemNotIn12u12DB = ref)}
          positiveAction={this.savedAddItem}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />

        <Valert
          display={false}
          title={t("general.CLEAR_CONFIRMATION_TITLE")}
          question={
            this.props.recipeForm.category == "999"
              ? t("recipe.CLEAR_RECIPE_TEXT")
              : t("recipe.CLEAR_REGIMEN_TEXT")
          }
          onRef={(ref) => (this.clearValert = ref)}
          positiveAction={this.clearRecipe}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("general.DUPLICATE_ENTRY_TITLE")}
          question={this.props.t("recipe.RECIPE_DUPLICATE_ENTRIES_TEXT")}
          onRef={(ref) => (this.showDuplicateError = ref)}
          positiveAction={() => {
            const { valertType, addDuplicateEntry, selectIdtoEdit } = this.state;

            // ✅ After handling duplicate, run pending value check if present
            if (this.pendingRangeCheck && typeof this.pendingRangeCheck === "function") {
              const handled = this.pendingRangeCheck();
              this.pendingRangeCheck = null;
              if (handled) return;
            }

            if (valertType === "updateAdd") {
              this.props.updateMode
                ? this.props.saveClicked()
                : this.ingredientSubmit();
            } else if (valertType === "optionUpdate") {
              addDuplicateEntry
                ? this.props.IngredientOptionAdded()
                : this.props.IngredientOptionUpdated(selectIdtoEdit);
              this.setState({ addDuplicateEntry: false });
            }
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
        />

        <Valert
          display={false}
          title={
            this.props.recipeForm.category == "999"
              ? this.props.t("recipe.RECIPE_REPLACE_TITLE")
              : this.props.t("recipe.REGIMEN_REPLACE_TITLE")
          }
          question={
            this.props.recipeForm.category == "999"
              ? this.props.t("recipe.RECIPE_REPLACE_TEXT")
              : this.props.t("recipe.REGIMEN_REPLACE_TEXT")
          }
          onRef={(ref) => (this.replaceAlert = ref)}
          positiveAction={() => {
            const selected =
              this.recipe && this.recipe.pendingSelection ||              // ✅ child (RecipeForm) cache
              null;

            if (!selected) {
              console.warn("[VAlert] ADD no selection payload");
              return;
            }

            this.props.replaceOrAddRecipe("add", selected); // ✅ dispatch with full object
            if (this.recipe) this.recipe.pendingSelection = null;
          }}
          positiveText={this.props.t("general.ADD_BUTTON_TEXT")}
          negativeText={this.props.t("meal_planner.REPLACE_BUTTON")}
          negativeAction={() => {
            const selected =
              this.recipe && this.recipe.pendingSelection ||              // ✅ child (RecipeForm) cache
              null;

            if (!selected) {
              console.warn("[VAlert] REPLACE no selection payload");
              return;
            }

            this.props.replaceOrAddRecipe("replace", selected); // ✅ dispatch with full object
            if (this.recipe) this.recipe.pendingSelection = null;
          }}
          thirdActionText={this.props.t("general.CANCEL")}
          ThirdAction={() => {
            const selected =
              this.recipe && this.recipe.pendingSelection ||              // ✅ child (RecipeForm) cache
              null;

            if (!selected) {
              console.warn("[VAlert] REPLACE no selection payload");
              return;
            }

            this.props.replaceOrAddRecipe("cancel", selected); // ✅ dispatch with full object
            if (this.recipe) this.recipe.pendingSelection = null;
          }}
        />
        <Valert
          display={false}
          title={
            this.props.category === "999"
              ? i18n.t("stocks.INCOMPLETE_INGREDIENT_TITLE")
              : i18n.t("general.INCOMPLETE_ITEM_PROMPT_TITLE")
          }
          question={
            this.props.category === "999"
              ? i18n.t("stocks.INCOMPLETE_INGREDIENT_TEXT")
              : i18n.t("general.RECIPE_INCOMPLETE_ITEM_PROMPT_TEXT")
          }
          onRef={(ref) => (this.IncompleteLastItem = ref)}
          positiveAction={() =>
            this.props.category === "999"
              ? this.submit()
              : this.updateRecipePos()
          }
          positiveText={i18n.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={i18n.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            this.props.category === "999"
              ? i18n.t("recipe.LAST_INGREDIENT_TITLE")
              : i18n.t("recipe.LAST_ITEM_TITLE")
          }
          question={
            this.props.category === "999"
              ? i18n.t("stocks.SAVE_PAGE_UNSAVED_RECIPE_ERROR_TEXT")
              : i18n.t("recipe.SAVE_PAGE_UNSAVED_REGIMEN_ERROR_TEXT")
          }
          onRef={(ref) => (this.LastItemNotAdded = ref)}
          positiveAction={() =>
            this.props.category === "999"
              ? this.submit()
              : this.updateRecipePos()
          }
          positiveText={i18n.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={i18n.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={i18n.t("general.INCOMPLETE_CHANGE_TITLE")}
          question={
            this.props.category === "999"
              ? i18n.t("general.INCOMPLETE_CHANGE_REGIMEN_TEXT")
              : i18n.t("general.INCOMPLETE_CHANGE_TEXT_2")
          }
          onRef={(ref) => (this.IncompleteChangeToSelectedItem = ref)}
          positiveAction={() =>
            this.props.category === "999"
              ? this.submit()
              : this.updateRecipePos()
          }
          positiveText={i18n.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={i18n.t("general.CANCEL")}
        />
        <Valert
          display={alreadyUsedRecipeName || alreadyUsedRecipeNameInContent }
          title={t("recipe.ALREADY_USED_RECIPE_NAME_TITLE")}
          question={
            alreadyUsedRecipeName
            ? t("recipe.ALREADY_USED_RECIPE_NAME_TEXT")
            : t("recipe.ALREADY_USED_RECIPE_NAME_TEXT")
          }
          children={
            alreadyUsedRecipeName
            ? [] 
            : <ListingText listing={this.props.deletedRecipeName} /> 
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />

        <Valert
          display={incompatibleIngredient}
          title={i18n.t("recipe.INCOMPATIBLE_INGREDIENT_TITLE")}
          question={i18n.t("recipe.INCOMPATIBLE_INGREDIENT_TEXT")}
          positiveText={i18n.t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />

        <Valert
          display={this.props.barcodeCategoryRef}
          onRef={(ref) => (this.barcodeCategoryRef = ref)}
          title={this.props.t("BARCODE.INCOMPATIBLE_BARCODE_CATEGORY_TITLE")}
          question={
            this.props.refdb_item
              ? this.props.recipeForm.category == "999"
                ? t("BARCODE.INCOMPATIBLE_CATEGORY_FOOD_RECIPE_TEXT").replace(
                  /{category}/g,
                  this.props.refdb_item_category
                )
                : t(
                  "BARCODE.INCOMPATIBLE_BARCODE_REFDB_CATEGORY_REGIMEN_TEXT"
                ).replace(/{category}/g, this.props.refdb_item_category)
              : this.props.recipeForm.category == "999"
                ? t(
                  "BARCODE.INCOMPATIBLE_CATEGORY_HISTORY_FOOD_RECIPE_TEXT"
                ).replace(/{category}/g, this.props.refdb_item_category)
                : t(
                  "BARCODE.INCOMPATIBLE_BARCODE_HISTORY_CATEGORY_REGIMEN_TEXT"
                ).replace(/{category}/g, this.props.refdb_item_category)
          }
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.searchIngredientOptions("", true);
          }}
          readOnly={true}
        />

        <Valert
          display={this.props.barcodeCategory}
          onRef={(ref) => (this.barcodeCategory = ref)}
          title={t("symptoms.INCORECT_CATEGORY_TITLE")}
          question={t("symptoms.INCORECT_CATEGORY_TEXT")}
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.invalidValue = ref)}
          title={t("general.INVALID_VALUE_TITLE")}
          question={t("general.INVALID_VALUE_TEXT")}
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.addCustomAlert}
          onRef={(ref) => (this.addCustomVAlert = ref)}
          title={t("BARCODE.OTHER_ENTRY_ERROR_TITLE")}
          question={
            this.props.recipeForm.category === "02" ||
              this.props.recipeForm.category == "999"
              ? t("BARCODE.OTHER_ENTRY_ERROR_FOOD_CATEGORY_TEXT")
              : t("BARCODE.OTHER_ENTRY_ERROR_OTHER_CATEGORIES_TEXT")
          }
          positiveAction={() => {
            this.setState({
              barcode: this.state.barcodeValue,
              displayAddCustomAlert: false,
            });
            this.setState({ barcodeValue: "" });
            this.barcodeAlertStatus.changeStatus();
            this.props.onChangeAlertStatus({
              item: { addCustomAlert: false },
            });
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.incorrectBarcodeCategory}
          title={this.props.t("BARCODE.INCORRECT_BARCODE_CATEGORY_TITLE")}
          question={
            this.props.recipeForm.category == "999"
              ? t("BARCODE.INCORRECT_FOOD_RECIPE_BARCODE_CATEGORY_TEXT")
              : t("BARCODE.INCORRECT_REGIMEN_BARCODE_CATEGORY_TEXT")
          }
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeAction={() => {
            this.props.searchIngredientOptions("", true);
          }}
          positiveAction={() => {
            this.props.IngredientOptionSelected(this.props.itemData);

            if (this.props.showVerificationPrompt === true) {
              this.props.onChangeAlertStatus({
                showVerificationPrompt: false,
                itemInVerAutofill: true,
                incorrectBarcodeCategory: false,
              });
            }

          }}
        />

        <Valert
          display={this.props.upc404}
          title={this.props.t("BARCODE.UPC404_ERROR_TITLE")}
          question={this.props.t("BARCODE.UPC404_ERROR_TEXT.TEXT")}
          positiveAction={async () => {
            await this.addBarcodeToField();
            if (!this.props.disabled.saveBtn) {
              sessionStorage.setItem(
                "previousPageIsDirty",
                this.getPreviousPageType()
              ); // Set previousPageIsDirty if Save or Update Regimen/Recipe button is enabled. Get the appropriate page title from "getPreviousPageType"
            }
            window.location.href = "/contribute?showBackBtn=true";
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          positiveText={this.props.t("general.CONTRIBUTE")}
          negativeText={this.props.t("general.CANCEL")}
          negativeAction={() => {
            this.props.searchIngredientOptions("", false, true);
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          onRef={(ref) => (this.contributeRedirectionAlert = ref)}
          disableAutoClose={true}
          thirdActionText={this.props.t("general.NEW")}
          ThirdAction={() => {
            this.props.searchIngredientOptions("", true);
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          children={<ListingText listing={this.props.listings} />}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.ProductNotContributed = ref)}
          title={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TITLE")}
          question={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TEXT")}
          positiveAction={this.addGreyUPC} // Call function to handle adding grey UPC to the Item Name field
          positiveText={t("general.CONTINUE_BUTTON")}
          negativeText={t("general.NEW")}
          negativeAction={() => {
            this.props.searchIngredientOptions("", true); // Clear UPC from Item Name field
            localStorage.removeItem("contDefault"); // ✅ Clear after clicking New button
            localStorage.removeItem("unContributed");
          }}
          children={
            <div style={{ fontSize: 14.4, color: "#555555", marginTop: 0 }}>
              <ul style={{ listStyleType: "disc", marginLeft: 12 }}>
                <li style={{ marginBottom: 5 }}>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET1_TEXT")}
                </li>
                <li>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET2_TEXT")}
                </li>
              </ul>
            </div>
          }
        />


        <MuiThemeProvider>
          <RecipeForm
            cuisineOptions={cuisineOptions}
            otherCuisineModal={this.otherCuisineModal}
            recipeOnChange={this.recipeOnChange}
            recipeOptions={recipeOptions}
            getIngredients={this.props.getIngredients}
            searchRecipeOptions={searchRecipeOptions}
            categorySelected={this.categorySelected.bind(this)}
            onSubmit={this.recipeSubmit}
            onRef={(ref) => (this.recipe = ref)}
            classNames={classNames}
            disabled={disabled}
            t={t}
            onChangeRecipeForm={onChangeRecipeForm}
            recipeForm={recipeForm}
            selectedCategory={this.props.selectedCategory}
            replaceOrAddRecipe={this.props.replaceOrAddRecipe}
            replaceAlert={this.replaceAlert}
            ingredientList={this.props.ingredientList}
            getRecipe={this.getRecipe}
            updateRecipeName={this.props.updateRecipeName}
            startsearchRecipeOptions={startsearchRecipeOptions}
            endsearchRecipeOptions={endsearchRecipeOptions}
            commitTypedRecipeName={commitTypedRecipeName}
          />
        </MuiThemeProvider>
        <div
          className={`grayList ingredient-list ${this.state.ingredientValidator && "is-invalid"
            }`}
          ref="ingredients_container"
          style={{
            flex: 1,
            backgroundColor: this.props.recipeForm.recipe
              ? "#f9fafb"
              : "#F1F3F5",
          }}
        >
          {!ingredientList ||
            (ingredientList.length === 0 && (
              <div className="usersItem">
                <Row style={{ padding: "4px 0 4px 4px" }}>
                  <Col>
                    <div>
                      <span className="desc" />
                      {this.props.t("recipe.INGREDIENTS_EMPTY_UPDATED")}
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          {ingredientList &&
            ingredientList.map((item, i) => {
              let unitName = "";
              let meas = [];
              if (this.props.category == "03") {
                meas = ACTIVITY_UNITS();
              } else if (this.props.category == "01") {
                meas = SYMPTOM_UNITS_NEW();
              } else if (this.props.category == "04") {
                meas = PCP_UNITS();
              } else if (this.props.category == "05") {
                meas = DRUG_UNITS();
              } else if (
                this.props.category == "02" ||
                this.props.category == "999"
              ) {
                meas = FOOD_UNITS();
              } else if (this.props.category == "06") {
                meas = SUP_UNITS();
              } else if (this.props.category == "07") {
                meas = LOC_UNITS();
              }

              for (const mea of meas) {
                if (mea._id == item.unitid) {
                  unitName = (mea.displayunit || "").trim();
                }
              }
              let ucpNumber = item.upc ? `(${item.upc})` : "";
              return (
                <div key={i} className="usersItem">
                  <Row
                    className={"wrapper" + (item.isSelected ? " selected" : "")}
                    // key={item.recipe + 1}
                    onClick={
                      recipeForm.recipe
                        ? this.ingredientItemOnClick.bind(this, i)
                        : ""
                    }
                    style={{
                      backgroundColor: recipeForm.recipe ? "#fff" : "#F1F3F5",
                      color: recipeForm.recipe ? "#000" : "#999",
                    }}
                  >
                    <Col xs="2">
                      {(item.size || item.value || "").toString().trim()}
                      {unitName ? ` ${unitName}` : ""}
                    </Col>
                    <Col xs="9">
                      <span
                        className="desc"
                        style={{ color: recipeForm.recipe ? "#000" : "#999" }}
                      >
                        {item.recipes ||
                          item.recipe ||
                          item.recipe_full ||
                          item.name}
                        {""}
                        {ucpNumber}
                      </span>
                    </Col>
                    <Col
                      xs="1"
                      className={
                        item.ingredients_text &&
                          item.ingredients_text.length > 0
                          ? "d-flex justify-content-between"
                          : "d-flex justify-content-end"
                      }
                      style={{ paddingTop: "3px", marginLeft: "7.4px" }}
                    >
                      {item.ingredients_text &&
                        item.ingredients_text.length > 0 && (
                          // <i
                          //   className="fas fa-info deleteIcon ml-0"
                          //   style={{
                          //     color: recipeForm.recipe ? "#007bff" : "#999",
                          //   }}
                          //   onClick={(e) => {
                          //     recipeForm.recipe
                          //       ? (e.stopPropagation(),
                          //         this.ingredientsModalHandler(
                          //           item.recipe_full,
                          //           item.ingredients_text
                          //         ))
                          //       : "";
                          //   }}
                          // />

                          <FontAwesomeIcon
                            className="fas fa-info-circle deleteIcon ml-0"
                            icon={faCircleInfo}
                            style={{
                              color: recipeForm.recipe ? "#007bff" : "#999",
                            }}
                            onClick={(e) => {
                              recipeForm.recipe
                                ? (e.stopPropagation(),
                                  this.ingredientsModalHandler(
                                    item.recipe_full,
                                    item.ingredients_text
                                  ))
                                : "";
                            }}
                          />

                        )}
                      <i
                        className="far fa-trash-alt deleteIcon"
                        style={{
                          marginLeft: "7px",
                          paddingLeft: "5px",
                          color: recipeForm.recipe ? "#007bff" : "#999",
                        }}
                        onClick={(e) => {
                          recipeForm.recipe
                            ? this.DeleteIconClicked(e, item, i)
                            : "";
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              );
            })}
        </div>
        <MuiThemeProvider>
          <IngredientForm
            measurementOptions={measurementOptions}
            scaleOptions={scaleOptions}
            ingredientOptions={ingredientOptions}
            searchIngredientOptions={searchIngredientOptions}
            onRef={(ref) => (this.ingredient = ref)}
            onSubmit={this.ingredientSubmit}
            isEditing={isEditing}
            ingredientSelected={ingredientSelected}
            t={t}
            classNames={classNames}
            disabled={disabled}
            onChangeIngredientForm={onChangeIngredientForm}
            amountReseter={amountReseter}
            amounNewValue={amounNewValue}
            replaceItemsAdded={replaceItemsAdded}
            IngredientOptionSelected={IngredientOptionSelected}
            ingredientForm={ingredientForm}
            recipeForm={recipeForm}
            bodyMapClicked={this.bodyMapClicked.bind(this)}
            barcodeClicked={this.barcodeAlert}
            barcodeImageClicked={this.barcodeImageAlert.bind(this)}
            recipeId={this.state.recipeId}
            partialResult={this.props.partialResult}
            barcodeSearch={this.props.barcodeSearch}
            addCustomAlert={this.addCustomAlert}
            barcode={this.props.upc404}
            hhmmMode={this.props.hhmmMode}
            setHHMMMode={this.props.setHHMMMode}
          />
        </MuiThemeProvider>
        <div className="row ops-section formRow baseRow">
          {!updateMode && !cancelMode && (
            <div className="col">
              <button
                type="button"
                className="btn btn-primary"
                style={{ fontSize: _btnFontSize }}
                onClick={this.AddItemClicked}
                disabled={disabled.addBtn}
              >
                {t("general.ADD_ITEM_BUTTON")}
              </button>
            </div>
          )}
          {!updateMode && cancelMode && (
            <div className="col">
              <button
                type="button"
                className="btn btn-primary"
                style={{ fontSize: _btnFontSize }}
                onClick={() => {
                  this.props.editIngredientItem(this.props.selectedIndex);
                }}
              >
                {t("general.CANCEL_ITEM_BUTTON")}
              </button>
            </div>
          )}
          {updateMode && !cancelMode && (
            <div className="col">
              <button
                type="button"
                className="btn btn-primary"
                style={{ fontSize: _btnFontSize }}
                disabled={disabled.addBtn}
                onClick={() => {
                  this.UpdateItemClicked(false);
                }}
              >
                {t("general.UPDATE_ITEM_BUTTON")}
              </button>
            </div>
          )}

          <div className="col">
            {updateMode && !cancelMode && (
              <button
                type="button"
                className="btn btn-primary"
                style={{ fontSize: _btnFontSize }}
                onClick={() => {
                  this.props.editIngredientItem(this.props.selectedIndex);
                }}
              >
                {t("general.CANCEL_ITEM_BUTTON")}
              </button>
            )}
            {!updateMode && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.SaveOrUpdateClicked}
                disabled={disabled.saveBtn}
              >
                {this.props.customRecipe
                  ? recipeForm.category == "999"
                    ? this.props.t("recipe.UPDATE_RECIPE_BUTTON")
                    : this.props.t("recipe.UPDATE_REGIMEN_BUTTON")
                  : recipeForm.category == "999"
                    ? this.props.t("recipe.SAVE_RECIPE_BUTTON")
                    : this.props.t("recipe.SAVE_REGIMEN_BUTTON")}
              </button>
            )}
          </div>
          <div className="col">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.askClearRecipe}
              disabled={disabled.clearBtn ? "disabled" : ""}
            >
              {t("general.CLEAR_PAGE_BUTTON")}
            </button>
          </div>
        </div>
        <br />
        <Prompt message={this.leave} />
      </div>
    );
  }
}

Recipe = translate("translations")(Recipe);

const mapStateToProps = (state) => ({
  ...state.recipe,
  formRecipeIngredient: state.form.formRecipeIngredient,
  formRecipe: state.form.formRecipe,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...recipeActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Recipe);



// WEBPACK FOOTER //
// ./src/pages/Recipe.js